/** Translations of the analytics area; wired up in lib/i18n/en.ts. */
export const analyticsFr = {
  title: 'Analyses',
  subtitle:
    "Chiffre d'affaires, marge de contribution et structure de clientèle sur des périodes librement sélectionnables.",
  tabs: {
    overview: 'Présentation',
    customers: 'Clients',
    products: 'Articles',
    geo: 'Régions',
  },
  filters: {
    preset: 'Période',
    dateFrom: 'Du',
    dateTo: 'Au',
    comparison: 'Comparaison',
    granularity: 'Granularité',
    export: 'Exportation CSV',
    presets: {
      last30Days: '30 derniers jours',
      currentMonth: 'Mois en cours',
      lastMonth: 'Mois précédent',
      currentQuarter: 'Trimestre en cours',
      currentYear: 'Année en cours',
      lastYear: 'Année précédente',
      custom: 'Personnalisé',
    },
    comparisons: {
      NONE: 'Aucune comparaison',
      PREVIOUS_PERIOD: 'Période précédente',
      PREVIOUS_YEAR: "Même période l'année dernière",
    },
    granularities: {
      DAY: 'Jour',
      WEEK: 'Semaine',
      MONTH: 'Mois',
      QUARTER: 'Trimestre',
    },
  },
  validation: {
    invalidRange: 'La date de début doit être antérieure à la date de fin.',
  },
  states: {
    error: "L'analyse n'a pas pu être chargée.",
    empty: 'Aucune donnée dans la période sélectionnée',
    emptyHint: 'Ajustez la période ou enregistrez les documents pour voir les analyses.',
  },
  export: {
    success: "L'export a été créé.",
  },
  kpi: {
    netRevenue: "Chiffre d'affaires net",
    grossProfit: 'Bénéfice brut',
    marginPct: 'Marge',
    averageOrderValue: 'Moy. valeur de la commande',
    invoiceCount: 'Factures',
    activeCustomers: 'Clients actifs',
    openReceivables: 'Créances ouvertes',
    cancelledOrderRatePct: "Taux d'annulation",
    comparedToPrevious: 'par rapport à la période de comparaison',
  },
  charts: {
    revenueTitle: 'Tendance des revenus',
    netRevenue: "Chiffre d'affaires net",
    grossProfit: 'Bénéfice brut',
    orderIntake: 'Prise de commandes',
    comparisonRevenue: 'Période de comparaison',
  },
  payment: {
    title: 'Statut de paiement de la facture',
    paid: 'Payé',
    open: 'Ouvert',
    overdue: 'En retard',
  },
  customers: {
    abcClass: 'Classe {{abcClass}}',
    abcSummary: 'Clients {{count}} · Partage des revenus {{share}}',
    atRisk: 'Risque de désabonnement',
    industryTitle: "Revenus par secteur d'activité",
    tableTitle: 'Analyse client',
    columns: {
      customer: 'Client',
      industry: 'Industrie',
      netRevenue: "Chiffre d'affaires net",
      grossProfit: 'Bénéfice brut',
      margin: 'Marge',
      orders: 'Commandes',
      lastOrder: 'Dernière commande',
      abc: 'ABC',
      churn: 'Désabonnement',
    },
    churn: {
      NONE: 'Sain',
      WARNING: 'Regarder',
      CRITICAL: 'Critique',
    },
  },
  products: {
    groupTitle: 'Marge contributive I par groupe de produits',
    tableTitle: 'Analyse du produit',
    slowMoverTitle: 'Mouvements lents',
    totals: {
      netRevenue: "Chiffre d'affaires net",
      costOfGoods: 'Coût des marchandises',
      contributionMargin1: 'Marge contributive I',
      productCount: 'Articles',
    },
    columns: {
      product: 'Article',
      group: 'Groupe de produits',
      quantity: 'Quantité',
      netRevenue: "Chiffre d'affaires net",
      contributionMargin1: 'CM I',
      contributionMargin2: 'CM II',
      margin: 'Marge',
      returnRate: 'Taux de retour',
      stockQuantity: 'Actions',
      stockValue: 'Valeur du stock',
      lastMovement: 'Dernier mouvement',
      daysSinceMovement: 'Jours sans mouvement',
    },
  },
  geo: {
    regionTitle: "Chiffre d'affaires par région",
    regionTableTitle: 'Régions',
    countryTitle: "Chiffre d'affaires par pays",
    regions: {
      DOMESTIC: 'National',
      EU: 'UE',
      THIRD_COUNTRY: 'Pays hors UE',
    },
    columns: {
      region: 'Région',
      country: 'Pays',
      netRevenue: "Chiffre d'affaires net",
      documents: 'Documents',
      customers: 'Clients',
      share: 'Partager',
    },
  },
};
